import { HttpService } from '@/utils/http/index'

const $http = new HttpService()

/**
 * 获取城市列表
 * @param params
 */
export const getCityListApi = () => $http.get('/ptapi/city/city_list')

/**
 * 获取城市列表（根据省分组）
 * @param params
 */
export const getProvinceCityListApi = () => $http.get('/cake_api/getCityListByBrandId')

/**
 * 获取物流公司列表
 * @param params
 */
export const getLogisticsCompanyApi = (params: object) => $http.get('/admin/merchant/get_express_code', params)

/**
 * 查看物流信息
 * @param params
 */
export const getLogisticsInfoApi = (shipper: string, logistic: string, customer: string) => $http.get('/dsapi/order/kdapi', { shipper, logistic, customer, urlPrefix: '/ci_api' })

// 各维度订单报表页面参数列表接口
export const getImportListApi = (params: object) => $http.get('/sys/admin/getImportList', params)